import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { MapOxxoTopicOne } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export class SceneTopicOne extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

	}


	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;
					this.camera.control.enableZoom = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
